@if(statusSummary?.next_maintenance; as next) {
<div class="status-page">
    <mat-icon>info</mat-icon>
    <div
        class="status-message"
        [innerHTML]="
            'STATUS_PAGE.MESSAGE'
                | translate
                    : {
                          fromDate: next?.start_date | date : 'dd.MM.YYYY, HH:mm',
                          toDate: next?.end_date | date : 'dd.MM.YYYY, HH:mm'
                      }
                | markdownIt
        "
    ></div>
</div>
} @else if (hasMaintenanceAccess && statusSummary?.status === status.UnderMaintenance) {
<div class="status-page">
    <mat-icon>info</mat-icon>
    <div class="status-message" [innerHTML]="'STATUS_PAGE.MAINTENANCE_MESSAGE' | translate"></div>
</div>
}
